import React from "react";
import "./ServiceOfferingsContent.css";
import Container from "@material-ui/core/Container";
import LearStraData from "./LearStraData.json";
import LearProgTab from './LearProgTab';

function ServiceOfferingsContent() {
  return (
    <>
      <div className="ser-off-main-container">
        <title>L&TT Portal - Service Offerings</title>
        <img
          src="images/serviceofferings/ser-off-banner.jpg"
          alt="banner"
          className="ser-off-banner"
        />
        <div className="banner-text">
          <h2>Innovate Your Learning Experience</h2>
          <p>Empowering Curiosity, Fostering Brilliance</p>
        </div>
      </div>
      {/* first section */}
      <div className="who-we-container-bg">
        <Container className="who-we-holder" maxWidth="xl">
          <h2>Who We Are?</h2>
          <div className="who-we-wrap">
            <div className="who-we-row">
              <div className="who-we-box box1">
                <p>
                  Welcome to our world of transformative learning strategies and
                  programs! At L&TT, we are passionate about driving success
                  through innovative education and skill enhancement.
                </p>
                <img
                  src="images/serviceofferings/hand-icon.png"
                  alt="icons"
                  className="who-we-icons"
                />
              </div>
            </div>
            <div className="who-we-row">
              <div className="who-we-box box2">
                <p>
                  We are on a mission to empower individuals and businesses to
                  thrive in an ever-evolving landscape by equipping them with
                  cutting-edge strategies and programs.
                </p>
                <img
                  src="images/serviceofferings/target-icon.png"
                  alt="icons"
                  className="who-we-icons"
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      {/* second section */}
      <div className="our-ser-off-container-bg">
        <Container className="ser-off-holder" maxWidth="xl">
          <h2>Our Service Offerings</h2>
          <div className="our-ser-off-wrap wrap1">
            <div className="our-ser-off-row row1">
              <div className="our-ser-off-box">
                <h3>Learning Strategy & Transformation</h3>
                <div className="lear-stra-wrap">
                  {LearStraData.map((item) => {
                    return (
                      <div key={item.id} className="lear-stra-row">
                        <div className="lear-stra-box">
                          <img
                            src={item.image}
                            alt="icons"
                            className="lear-stra-icons"
                          />
                          <p>{item.para}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="our-ser-off-row row2">
              <div className="our-ser-off-box">
                <img
                  src="images/serviceofferings/lear-stra-img.png"
                  alt="service"
                  className="our-ser-off-img"
                />
              </div>
            </div>
          </div>
          <div className="our-ser-off-wrap wrap1 second-wrap">
            <div className="our-ser-off-row row2">
              <div className="our-ser-off-box">
                <img
                  src="images/serviceofferings/lear-prog-img.png"
                  alt="service"
                  className="our-ser-off-img"
                />
              </div>
            </div>
            <div className="our-ser-off-row row1">
              <div className="our-ser-off-box lear-prog-box">
                <h3>Learning Programs</h3>
                <LearProgTab />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default ServiceOfferingsContent;
